import ChatbotDefaults from "pages/Admin/ChatbotDefaults";

export default function ChatbotDefaultsPage() {
  return <ChatbotDefaults />;
}
